import { useContext, useEffect } from "react";
import AppContext from "../../state/AppContext";
import UserContext from "../../state/UserContext";
import { localStorageHelper, localStorageKeys } from "../../helpers";
import {
  ACCESSIBE_HIDDEN_BODY_CLASS,
  isAccessibeEnabledForClient,
} from "../../config/third-party/accessibeConfig";

/** This loads the Accessibe script for the accessibility plugin */
export const AccessibePlugin = () => {
  const appContext = useContext(AppContext);
  const userContext = useContext(UserContext);
  const scriptTagIdentifier = "accessibe-script";

  const clientId = userContext?.user?.client?.id;
  const employeeId = userContext?.user?.id;
  const isEnabled = isAccessibeEnabledForClient(clientId);

  useEffect(() => {
    conditionallyAddScriptToBody();
  }, [clientId]);

  // Pick up the choice this employee made last time they were in this browser
  useEffect(() => {
    if (!isEnabled || !employeeId) return;

    appContext.setAccessibilityToolHidden(
      localStorageHelper.getItem(
        localStorageKeys.accessibilityToolHidden(employeeId)
      ) === "true"
    );
  }, [isEnabled, employeeId]);

  // Accessibe has no supported way to toggle `hideTrigger` after init, so the
  // widget is hidden with CSS instead. Adjustments the user already applied stay
  // active; only the widget's own UI goes away.
  useEffect(() => {
    if (appContext.accessibilityToolHidden) {
      document.body.classList.add(ACCESSIBE_HIDDEN_BODY_CLASS);
    } else {
      document.body.classList.remove(ACCESSIBE_HIDDEN_BODY_CLASS);
    }
  }, [appContext.accessibilityToolHidden]);

  const conditionallyAddScriptToBody = () => {
    if (!isEnabled) return;

    // Don't add the script for a second time
    if (document.getElementById(scriptTagIdentifier)) {
      return;
    }

    const script = document.createElement("script");
    script.id = scriptTagIdentifier;
    script.src = "https://acsbapp.com/apps/app/dist/js/app.js";
    script.async = true;
    script.onload = () => {
      // @ts-ignore
      window.acsbJS.init({
        statementLink: "",
        footerHtml: "",
        hideMobile: false,
        hideTrigger: false,
        disableBgProcess: false,
        language: "en",
        position: "right",
        leadColor: "#146FF8",
        triggerColor: "#146FF8",
        triggerRadius: "50%",
        triggerPositionX: "right",
        triggerPositionY: "bottom",
        triggerIcon: "people",
        triggerSize: "bottom",
        triggerOffsetX: 20,
        triggerOffsetY: 20,
        mobile: {
          triggerSize: "small",
          triggerPositionX: "right",
          triggerPositionY: "bottom",
          triggerOffsetX: 10,
          triggerOffsetY: 10,
          triggerRadius: "20",
        },
      });
    };
    document.body.appendChild(script);
  };

  return null;
};
export default AccessibePlugin;
